import { render, staticRenderFns } from "./TheSpeakersCarousel.vue?vue&type=template&id=287724ae&scoped=true&"
import script from "./TheSpeakersCarousel.vue?vue&type=script&lang=js&"
export * from "./TheSpeakersCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TheSpeakersCarousel.vue?vue&type=style&index=0&id=287724ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287724ae",
  null
  
)

export default component.exports